var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{attrs:{"id":"IframeTicket","frameborder":"0"}}),_c('v-btn',{staticClass:"ma-1",attrs:{"disabled":_vm.faltaDinero,"color":"info","dark":"","block":""},on:{"click":function($event){return _vm.printActualTicket()}}},[_vm._v("Imprimir Ticket")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }